import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PropTypes from 'prop-types';
import { useState } from 'react';

import EditPartnerDialog from './EditPartnerDialog';

// Only the identity value is editable here; a partner link is never removed from this tab (POM-6492).
const PatientPartnerOptions = ({ partnerId, mpi }) => {
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = !!anchorEl;

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleShowEditDialog = () => {
    setShowEditDialog(true);
    handleMenuClose();
  };

  const handleCloseEditDialog = () => setShowEditDialog(false);

  return (
    <>
      <EditPartnerDialog
        mpi={mpi}
        partnerId={partnerId}
        open={showEditDialog}
        onClose={handleCloseEditDialog}
      />

      <IconButton
        id={`PatientView-PatientPartnerOptions-${partnerId}options-button`}
        aria-label={`Partner options ${partnerId}`}
        aria-controls={
          menuOpen ? `PatientView-PatientPartnerOptions-${partnerId}options-menu` : undefined
        }
        aria-haspopup='true'
        aria-expanded={menuOpen ? 'true' : undefined}
        onClick={handleMenuOpen}
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        id={`PatientView-PatientPartnerOptions-${partnerId}options-menu`}
        aria-labelledby={`PatientView-PatientPartnerOptions-${partnerId}options-button`}
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleShowEditDialog}>Edit</MenuItem>
      </Menu>
    </>
  );
};

PatientPartnerOptions.propTypes = {
  partnerId: PropTypes.string.isRequired,
  mpi: PropTypes.string.isRequired,
};
export default PatientPartnerOptions;
